import { UrlParamsReplace } from '@services/url.service';

import { postWithAuth } from '@services/http.service';

const ONE_TAP_VERIFY_TOKEN_URL = () => UrlParamsReplace('oauth/google');
export const verifyGoogleOneTapToken = (jwtToken: string | undefined) => postWithAuth(ONE_TAP_VERIFY_TOKEN_URL(), { jwtToken });

const ACCESS_TOKEN_URL = () => UrlParamsReplace('oauth/access/google');
export const verifyGoogleAccessToken = (jwtToken: string | undefined) => postWithAuth(ACCESS_TOKEN_URL(), { jwtToken });
